import React from 'react';
import { Box } from '@chakra-ui/react';
import { HeatmapStrategy } from '../../../models/sessions';

const HEATMAP_BG: Record<string, string> = {
  'hm-1': '#ecfdf5',
  'hm-2': '#d1fae5',
  'hm-3': '#a7f3d0',
  'hm-4': '#fef3c7',
  'hm-5': '#fde68a',
  'hm-6': '#fbbf24',
  'hm-7': '#fca5a5',
};

interface HeatmapCellProps {
  value: number | undefined;
  strategy: HeatmapStrategy | undefined;
  decimals?: number;
}

function mapToLevel(
  value: number,
  strategy: HeatmapStrategy,
): string | undefined {
  if (strategy.kind === 'none') return undefined;
  const levels = ['hm-1', 'hm-2', 'hm-3', 'hm-4', 'hm-5', 'hm-6', 'hm-7'];
  for (let i = 0; i < strategy.breaks.length; i++) {
    if (value < strategy.breaks[i]) return levels[i];
  }
  return levels[levels.length - 1];
}

function fmt(value: number | undefined, decimals = 0): string {
  if (value === undefined || Number.isNaN(value)) return '—';
  if (decimals === 0) {
    return Math.round(value).toLocaleString('it-IT');
  }
  return value.toLocaleString('it-IT', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export const HeatmapCell: React.FC<HeatmapCellProps> = ({
  value,
  strategy,
  decimals,
}) => {
  if (value === undefined) {
    return (
      <Box textAlign="center" color="gray.400" fontFamily="mono">
        —
      </Box>
    );
  }
  const level = strategy ? mapToLevel(value, strategy) : undefined;
  const bg = level ? HEATMAP_BG[level] : 'transparent';
  return (
    <Box
      textAlign="center"
      bg={bg}
      px={2}
      py={1}
      borderRadius="sm"
      fontFamily="mono"
      fontWeight="500"
      fontSize="13px"
      color="#0b2b3c"
    >
      {fmt(value, decimals)}
    </Box>
  );
};
